import React from "react";

import LogoGmail from "../assets/logos/mail/logo_gmail.png";
import LogoOutlook from "../assets/logos/mail/logo_outlook.png";
import { Alert } from "@material-ui/lab";

const emailButtonStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  cursor: "pointer",
};

const CheckEmail = ({ institutionAccount }) => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  const getEmailDeepLink = (emailType) => {
    const searchQuery = "Validation Code for The Zone";
    const encodedQuery = encodeURIComponent(searchQuery);
    let realUrl = "";
    if (emailType === "gmail") {
      realUrl = isMobile
        ? `gmail:search/subject:(${encodedQuery})`
        : `https://mail.google.com/mail/u/0/#search/subject:(${encodedQuery})`;
    } else if (emailType === "outlook") {
      const outlookUrl = institutionAccount
        ? `https://outlook.office.com/mail/search/${encodedQuery}`
        : `https://outlook.live.com/mail/search/${encodedQuery}`;
      realUrl = isMobile
        ? `ms-outlook://mail/search/${encodedQuery}`
        : outlookUrl;
    } else {
      return;
    }
    if (realUrl.startsWith("http")) {
      window.open(realUrl, "_blank");
    } else {
      window.location.href = realUrl;
    }
  };

  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        color: "#3F4254",
        marginTop: "20px",
      }}
    >
      <Alert className="mb-2" severity="info">
        Check your email for the OTP code. Click the logo to open your email
        client.
        <br />
        Don't use Gmail or Outlook? Check your email provider's inbox for the
        OTP code.
      </Alert>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "30px",
          margin: "20px 0",
        }}
      >
        <div style={emailButtonStyle} onClick={() => getEmailDeepLink("gmail")}>
          <img src={LogoGmail} alt="logo-gmail" width={30} />
          <span style={{ color: "#3F4254" }}>Gmail</span>
        </div>
        <div
          style={emailButtonStyle}
          onClick={() => getEmailDeepLink("outlook")}
        >
          <img src={LogoOutlook} alt="logo-outlook" width={30} />
          <span style={{ color: "#3F4254" }}>Outlook</span>
        </div>
      </div>
    </div>
  );
};

export default CheckEmail;
